import React from 'react';

import { LIVE_TAB_LABELS } from './tabs';

/*
 * PROD-7828 — placeholder for the tabs that land in later releases (D-6).
 * Deliberately data-free: the module must not show a single invented number anywhere.
 */
const live_text = `${LIVE_TAB_LABELS.slice(0, -1).join(', ')} and ${LIVE_TAB_LABELS.slice(-1)[0]}`;

const StubTab = ({ label, release }) => (
  <div className="tp-banner tp-banner-info">
    <b>{label}</b> is not built yet — coming in {release || 'a later release'}. {live_text} are
    live; nothing on this tab is.
  </div>
);

export default StubTab;
